import onDocumentReady from './document_ready';
import onWindowPageshow from './window_pageshow';

// ****** Bindings To Native Events On Window ******
$(window).bind('pageshow', onWindowPageshow);

// ****** Bindings To Native Events On Document ******
$(document).ready(onDocumentReady);
